import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['manageCalling'],
});

export const manageCallingApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findManageCallingByCallingno: builder.query({
      query: (payload) => ({
        url: `manage_callingsheets/?calling_no=${payload.calling_no}`,
        method: 'GET',
      }),
      invalidatesTags: ['manageCalling'],
    }),
    getPrintCallingByCallingno: builder.query({
      query: (calling_no) => ({
        url: `manage_callingsheets/?calling_no=${calling_no}`,
        method: 'GET',
      }),
      invalidatesTags: ['manageCalling'],
    }),
    createManageCalling: builder.mutation({
      query: (postData) => ({
        url: `manage_callingsheets/create_or_update/`,
        method: 'POST',
        body: postData,
      }),
      invalidatesTags: ['manageCalling'],
    }),

    findLocationFrom: builder.query({
      query: () => ({
        url: `manage_callingsheets/location_from/`,
        method: 'GET',
      }),
    }),

    //cancalManageCalling
    deleteManageCalling: builder.mutation({
      query: (id) => ({
        url: `manage_callingsheets/cancel/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['manageCalling'],
    }),

    getPrintDN: builder.query({
      query: (calling_no) => ({
        url: `dn_list/print/?calling_no=${calling_no.calling_no}`,
        method: 'GET',
      }),
    }),

    getGenerateCallingNo: builder.query({
      query: () => ({
        url: `callingsheets/generate_calling_no/`,
        method: 'GET',
      }),
      invalidatesTags: ['manageCalling'],
    }),

    getCheckTrDv: builder.mutation({
      query: (payload) => ({
        url: `callingsheets/check_match_tr_dv/${payload.id}/`,
        method: 'GET',
      }),
      invalidatesTags: ['manageCalling'],
    }),

    checkBestReceiveJobTime: builder.mutation({
      query: (body) => ({
        url: `manage_callingsheets/check_best_receive_job_time/`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['manageCalling'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyFindLocationFromQuery,
  useFindLocationFromQuery,
  useLazyFindManageCallingByCallingnoQuery,
  useDeleteManageCallingMutation,
  useCreateManageCallingMutation,
  useGetPrintDNQuery,
  useLazyGetGenerateCallingNoQuery,
  useGetCheckTrDvMutation,
  useCheckBestReceiveJobTimeMutation,
} = manageCallingApi;
